import avatarKaterina from "@assets/images/team/katerina-stoksova-avatar.jpg?webp&imagetools";
import imageKaterina from "@assets/images/team/katerina-stoksova.jpg?webp&imagetools";
import avatarSvetlana from "@assets/images/team/svetlana-uskova-avatar.jpg?webp&imagetools";
import imageSvetlana from "@assets/images/team/svetlana-uskova.jpg?webp&imagetools";
import { Locale, type LocalizedString } from "@core/schema/Locale.js";
import { jsNormalize } from "@core/utils/jsNormalize.js";

interface MediaSrc {
	src: string;
	width: number;
	height: number;
}

export interface CourseTrainer {
	name: string;
	city: LocalizedString;
	bio: LocalizedString;
	highlight: LocalizedString;
	placeKeywords: string[];
	image: MediaSrc;
	avatar: MediaSrc;
}

export const courseTrainers: CourseTrainer[] = [
	{
		name: "Kateřina Štoksová",
		city: {
			[Locale.cs]: "Praha",
			[Locale.en]: "Prague",
		},
		bio: {
			[Locale.cs]:
				"Kateřina je zkušená kávová lektorka. Pravidelně školí naše velkoobchodní partnery a stará se o provoz Father’s Coffee Storu. Má za sebou mnoho kávových soutěží a úspěchů. V roce 2020 získala 2. místo v soutěži Brewers Cup a v letech 2023 i 2024 obsadila druhé místo v soutěži Barista roku.",
			[Locale.en]:
				"Kateřina is an experienced coffee trainer. She regularly trains our wholesale partners and runs the Father’s Coffee Store. She has many coffee competitions and achievements behind her. In 2020 she took 2nd place in the Brewers Cup, and in both 2023 and 2024 she finished second in the Barista of the Year competition.",
		},
		highlight: {
			[Locale.cs]: "2. místo v soutěži Barista roku 2023 a 2024",
			[Locale.en]: "2nd place, Barista of the Year 2023 and 2024",
		},
		placeKeywords: ["Praha", "Prague", "Bubenečská", "Coffee Store"],
		image: { src: imageKaterina, width: 308, height: 462 },
		avatar: { src: avatarKaterina, width: 100, height: 99 },
	},
	{
		name: "Světlana Uskova",
		city: {
			[Locale.cs]: "Ostrava",
			[Locale.en]: "Ostrava",
		},
		bio: {
			[Locale.cs]:
				"Světlana se kávě věnuje už dlouho. Celkem 6 let pracovala jako baristka, později jako headbaristka v kavárně U Černého stromu. V roce 2023 se zúčastnila baristické soutěže Barista Cup Ostrava a získala první místo. Poté se přesunula do naší pražírny, kde nyní pracuje jako produkční pražič, součást QC týmu a lektorka kurzů přípravy kávy.",
			[Locale.en]:
				"Světlana has been devoted to coffee for a long time. She worked as a barista for six years in total, later as head barista at the U Černého stromu café. In 2023 she took part in the Barista Cup Ostrava competition and won first place. She then moved to our roastery, where she now works as a production roaster, a member of the QC team and a trainer of our coffee brewing courses.",
		},
		highlight: {
			[Locale.cs]: "1. místo v soutěži Barista Cup Ostrava 2023",
			[Locale.en]: "1st place, Barista Cup Ostrava 2023",
		},
		placeKeywords: ["Ostrava", "Mitrovická", "Roastery"],
		image: { src: imageSvetlana, width: 330, height: 462 },
		avatar: { src: avatarSvetlana, width: 100, height: 100 },
	},
];

export function findCourseTrainerByPlace(placeName: string): CourseTrainer | undefined {
	const place = jsNormalize(placeName);
	return courseTrainers.find(({ placeKeywords }) =>
		placeKeywords.some((keyword) => place.includes(jsNormalize(keyword))),
	);
}
